import React, { useState } from "react";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import ViewListOutlinedIcon from "@mui/icons-material/ViewListOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import ImageGrid from "../components/ImageGrid";
import ImageListView from "../components/ImageListView";
import Footer from "../components/Footer";

const photos = [
  {
    src: "/images/marija_2.jpeg",
    description: "Work less and travel more 😉",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_17.jpeg",
    description: "I had to take this one 😊📷",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_18.jpeg",
    description: "This might be my default look 👀",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_3.jpeg",
    description: "Making my way downtown ✨",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_4.jpeg",
    description: "🌞😌",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_5.jpeg",
    description: "🌊 #happyplace",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_6.jpeg",
    description: "Jedna spontana pred put #roadtrip",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_7.jpeg",
    description: "Working from home #mood",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_8.jpeg",
    description: "Wondering and wandering 😏",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_9.jpeg",
    description: "🐶: Hoću i ja #selfie! 😂",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_10.jpeg",
    description: "My inner child right now be like... 🙃",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_11.jpeg",
    description: "🌻✈️😃",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_12.jpeg",
    description: "In the eye of the storm 👁️",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_13.jpeg",
    description: "I'm just a 🌻 in the 🌎",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_14.jpeg",
    description: "HR mode: ON 👓☕☀️",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_15.jpeg",
    description: "🪷",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
  {
    src: "/images/marija_16.jpeg",
    description: "#wildbeach #vibes 🏖️",
    tags: [{ name: "Marija", url: "/facegram-phone/marija" }],
  },
];

// neki mock followersi da ima šta da se prikaže
const followersList = [
  { username: "luna_bloom", name: "Luna Bloom" },
  { username: "neo_shadow", name: "Neo Shadow" },
  { username: "aurora_wave", name: "Aurora Wave" },
  { username: "matt_the_wanderer", name: "Matt The Wanderer" },
  { username: "sara_vision", name: "Sara Vision" },
  { username: "echo_zero", name: "Echo Zero" },
  { username: "ruby_lane", name: "Ruby Lane" },
  { username: "ghost_pixel", name: "Ghost Pixel" },
  { username: "alexa_mirage", name: "Alexa Mirage" },
  { username: "finch_cobalt", name: "Finch Cobalt" },
  { username: "nova_spirit", name: "Nova Spirit" },
  { username: "mila_star", name: "Mila Star" },
  { username: "zack_flux", name: "Zack Flux" },
  { username: "iris_haven", name: "Iris Haven" },
  { username: "kai_drifter", name: "Kai Drifter" },
  { username: "stella_arc", name: "Stella Arc" },
  { username: "zero_nimbus", name: "Zero Nimbus" },
  { username: "oliver_quest", name: "Oliver Quest" },
  { username: "vexa_loop", name: "Vexa Loop" },
  { username: "nina_sol", name: "Nina Sol" },
  { username: "crystal_muse", name: "Crystal Muse" },
  { username: "leo_north", name: "Leo North" },
  { username: "aria_nova", name: "Aria Nova" },
  { username: "jayden_blaze", name: "Jayden Blaze" },
  { username: "mira_dusk", name: "Mira Dusk" },
  { username: "riley_echo", name: "Riley Echo" },
  { username: "noah_zen", name: "Noah Zen" },
  { username: "tessa_vault", name: "Tessa Vault" },
  { username: "draco_wave", name: "Draco Wave" },
  { username: "vega_rise", name: "Vega Rise" },
];

export default function InstagramMobile({
  username = "marija_s",
  bio = "Life is supposed to be fun! content creator",
  avatarUrl = "/images/marija_1.png",
  posts = 730,
  followers = "8k",
  following = 671,
}) {
  const [activeTab, setActiveTab] = useState("grid");
  const [currentView, setCurrentView] = useState("profile"); // "profile" | "followers"
  const [searchTerm, setSearchTerm] = useState("");
  const [showNoResults, setShowNoResults] = useState(false);
  const [savedModalOpen, setSavedModalOpen] = useState(false);
  const [searchModalOpen, setSearchModalOpen] = useState(false);
  const [searchShowTags, setSearchShowTags] = useState(false);

  const savedPhoto = {
    src: "/images/marija_saved2.jpeg",
    description: "JOŠ SAMO MALO DO TVOJE NOVE ETAPE! ✨",
  };

  const searchPhoto = {
    src: "/images/marija_objava.jpg",
    description: "Društvene igre ili alkohol?\nOdgovor: DA!",
    tags: [
      { name: "marija_s", url: "/facegram-phone/marija" },
      { name: "mr.wolf", url: "/facegram-phone/vuk-janko" },
      { name: "zoka77", url: null },
      { name: "jelena.dan", url: null },
      { name: "#nenad", url: null },
    ],
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const handleFollowersClick = () => {
    setCurrentView("followers");
    setSearchTerm("");
    setShowNoResults(false);
  };

  const handleBackToProfile = () => {
    setCurrentView("profile");
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    if (searchTerm.trim() !== "") {
      setShowNoResults(true);
    } else {
      setShowNoResults(false);
    }
  };

  return (
    <div className="ph-wrap">
      {currentView === "profile" ? (
        <>
          <div className="ph-top">
            <div className="ph-avatar-ring">
              <img
                className="ph-avatar"
                src={avatarUrl}
                alt={`${username} avatar`}
              />
            </div>

            <div className="ph-user">
              <div className="ph-row">
                <div className="ph-username">{username}</div>
              </div>
              <div className="ph-bio">{bio}</div>
            </div>
            <div className="ph-button">
              <button className="ph-more" aria-label="More options">
                ⋯
              </button>
            </div>
          </div>

          <div className="ph-actions">
            <button className="ph-btn-following">Following</button>
            <button className="ph-btn-message">Message</button>
            <button className="ph-btn-icon" aria-label="Add">
              <span className="ph-plus">＋</span>
            </button>
          </div>

          <div className="ph-stats">
            <div className="ph-stat">
              <div className="ph-num">{posts}</div>
              <div className="ph-label">posts</div>
            </div>

            <div
              className="ph-stat ph-stat-clickable"
              onClick={handleFollowersClick}
            >
              <div className="ph-num">{followers}</div>
              <div className="ph-label">followers</div>
            </div>

            <div className="ph-stat">
              <div className="ph-num">{following}</div>
              <div className="ph-label">following</div>
            </div>
          </div>

          <div className="profile-tabs">
            <GridOnOutlinedIcon
              className={`tab-icon ${activeTab === "grid" ? "active" : ""}`}
              fontSize="large"
              onClick={() => handleTabClick("grid")}
            />

            <ViewListOutlinedIcon
              className={`tab-icon ${activeTab === "list" ? "active" : ""}`}
              fontSize="large"
              onClick={() => handleTabClick("list")}
            />

            <SearchOutlinedIcon
              className={`tab-icon ${activeTab === "search" ? "active" : ""}`}
              fontSize="large"
              onClick={() => handleTabClick("search")}
            />

            <BookmarkBorderOutlinedIcon
              className={`tab-icon ${activeTab === "saved" ? "active" : ""}`}
              fontSize="large"
              onClick={() => handleTabClick("saved")}
            />
          </div>

          {activeTab === "grid" && <ImageGrid images={photos} />}
          {activeTab === "list" && <ImageListView images={photos} />}
          {activeTab === "search" && (
            <>
              <img
                src={searchPhoto.src}
                alt="objava"
                className="saved-full-img"
                onClick={() => { setSearchModalOpen(true); setSearchShowTags(false); }}
              />

              {searchModalOpen && (
                <div className="modal-overlay" onClick={() => setSearchModalOpen(false)}>
                  <div className="modal-box" onClick={(e) => e.stopPropagation()}>
                    <button className="close-btn" onClick={() => setSearchModalOpen(false)}>
                      ✕
                    </button>
                    <img
                      src={searchPhoto.src}
                      alt="objava"
                      className="modal-img"
                      onClick={() => setSearchShowTags((prev) => !prev)}
                    />
                    <p className="modal-description" style={{ whiteSpace: "pre-line" }}>
                      {searchPhoto.description}
                    </p>
                    {searchShowTags && (
                      <div className="modal-tags">
                        {searchPhoto.tags.map((tag, i) => (
                          <button
                            key={i}
                            className="tag-pill"
                            onClick={() => tag.url && (window.location.href = tag.url)}
                            style={{ cursor: tag.url ? "pointer" : "default", opacity: tag.url ? 1 : 1 }}
                          >
                            {tag.name}
                          </button>
                        ))}
                      </div>
                    )}
                    <div className="modal-text">
                      <span>14 likes</span>
                      <span>2 comments</span>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          {activeTab === "saved" && (
            <>
              <img
                src={savedPhoto.src}
                alt="saved"
                className="saved-full-img"
                onClick={() => setSavedModalOpen(true)}
              />

              {savedModalOpen && (
                <div className="modal-overlay" onClick={() => setSavedModalOpen(false)}>
                  <div className="modal-box" onClick={(e) => e.stopPropagation()}>
                    <button className="close-btn" onClick={() => setSavedModalOpen(false)}>
                      ✕
                    </button>
                    <img
                      src={savedPhoto.src}
                      alt="saved"
                      className="modal-img"
                    />
                    <p className="modal-description">{savedPhoto.description}</p>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      ) : (
        // FOLLOWERS "STRANA"
        <div className="followers-view">
          <div className="followers-header">
            <button className="followers-back" onClick={handleBackToProfile}>
              ←
            </button>
            <span className="followers-title">Followers</span>
          </div>

          <form className="followers-search" onSubmit={handleSearchSubmit}>
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setShowNoResults(false);
              }}
            />
          </form>

          {showNoResults ? (
            <div className="no-results">Nema rezultata</div>
          ) : (
            <div className="followers-list">
              {followersList.map((follower) => (
                <div key={follower.username} className="follower-item">
                  <div className="follower-avatar-placeholder" />
                  <div className="follower-info">
                    <div className="follower-username">{follower.username}</div>
                    <div className="follower-name">{follower.name}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      <Footer page="home" />
    </div>
  );
}
